module.exports = __webpack_public_path__ + "213ca2be1b4079ffeb21b2c109282f2b.svg";